import { Component, OnInit, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { AttestationModel, CopiesTypeModel, DegreeModel, DegreeModelList } from '../attestation-details/model/attestationModel';
import { PucaComponent } from '../../puca.component';
import { ReviewDetailsService } from './services/review-details.service';
import { NgForm, FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SuccessDasComponent } from '../../../../../shared/shared-components/modal/success-das//success-das.component';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';
import { CommentsListComponent } from '../../../../../shared/shared-components/modal/comments-list/comments-list.component';
import { GoogleAnalyticsService } from '../../../../../shared/sharedServices/google-analytics.service';
import { decrypt } from '../../../../../utilities/utilityFunctions';

@Component({
  selector: 'kt-review-details',
  templateUrl: './review-details.component.html',
  styleUrls: ['./review-details.component.css']
})
export class ReviewDetailsComponent implements OnInit {
  @ViewChild('reviewDetailsForm', { static: false }) reviewDetailsForm: NgForm;

  @Input('dasApplicationData') dasApplicationData: AttestationModel = new AttestationModel();
  @Input('dropdownValuesForDas') dropdownValuesForDas: any;
  public userNameType:any = JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType;
  public userIdentityNum = JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType == 1? JSON.parse(decrypt(localStorage.getItem('loginDetails'))).cnic : JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userName;
  public userName=decrypt(localStorage.getItem('name'));
  public degreeInfos:any;
  public degreesData:any =[];
  public amountForDegrees: any = [];
  public amountForDegreeInt: any = [];
  public attestationRates: any;
  public totalForLocal:any=0;
  public totalForInt:any=0;
  public loader:boolean=false;
  public isError:boolean=false;
  public alertType:string;
  public errorMsg:string;
  public nadraMsg:string = 'We are unable to confirm your CNIC from NADRA. Please try again later. For further details, kindly contact at info.ana@hec.gov.pk.'
  public formView:string;
  public address:any;
  public todayDate = new Date();
  public userCnicType:string = 'CNIC'
  public totalAmountForDegrees: any = [];
  public degreeDetails:any=[]
  public degreeAttestationForm: FormGroup;
  public attestationData:any = [];
  public degreeStatus: any = [];
  public duplicateStatus: any = [];
  public degreeStampVerified: any = [];
  constructor(private parentComp: PucaComponent,private cdr:ChangeDetectorRef,private router:Router,private gaService:GoogleAnalyticsService,
    private reviewDetailsService:ReviewDetailsService,private matDialog: MatDialog,private fb: FormBuilder,
    private loaderService:LoaderService) { }

  ngOnInit() {
    window.scroll(0,0)
    this.gaService.setPage('/form','ESP Page');
    if(JSON.parse(decrypt(localStorage.getItem('loginDetails'))).userNameType != 1){
      this.userCnicType = 'Passport'
    }
    this.formView = this.parentComp.formType;
    this.address = JSON.parse(decrypt(localStorage.getItem('addresses')))
   this.degreeInfos =this.dropdownValuesForDas.map['6005'];
    this.attestationRates = this.dropdownValuesForDas.attestationRates;
    this.getDegreesData();
    this.createDegreeAttestationForm();
    for (let i = 0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length; i++) {
      this.getDegreeList();
      this.amountForDegrees.push(new DegreeModel());
    for (let k = 0; k < this.degreeInfos.length; k++) {
      this.getAttestationList(i, this.degreeInfos[k].value, this.dasApplicationData.dasApplicationDto.dasDegrees[i]);
      this.amountForDegrees[i].degreeList.push(new DegreeModelList())

    }
  }
    this.setDataAttestationFormData();

  }
  public goNext() {
    this.markFormsTouched(this.reviewDetailsForm)
    if (this.validate(this.reviewDetailsForm) ){
      this.loader=true;
      this.loaderService.setValue(this.loader);
      this.dasApplicationData.dasApplicationDto.submittedDate = new Date(this.todayDate).getFullYear() +'-'+(new Date(this.todayDate).getMonth()+1)+'-'+new Date(this.todayDate).getDate()
      this.dasApplicationData.dasApplicationDto.isNadraDetailsUpdated = this.reviewDetailsForm.value.isNadraDetailsUpdated;
      let payload = {
        data: {
          dasApplicationDto: this.dasApplicationData.dasApplicationDto
        }
      }
      if(this.formView == 'pucaRevision'){
        payload.data.dasApplicationDto['applicationStatusCodeId'] = 600827
      }
      if(this.reviewDetailsForm.value.comments){
      payload.data['dasAuditTrailDtoList'] = [{
        "applicationId": this.dasApplicationData.dasApplicationDto.id,
        "comments": this.reviewDetailsForm.value.comments,
        "commentsDate": new Date(this.todayDate).getFullYear() +'-'+(new Date(this.todayDate).getMonth()+1)+'-'+new Date(this.todayDate).getDate(),
        "userName": this.userIdentityNum,
        "userNameType" : 600191
      }]
    }
      if(this.formView != 'pucaRevision'){
      this.reviewDetailsService.saveApplicationData(payload).subscribe(
        (res)=>{
          this.loader=false;
          this.loaderService.setValue(this.loader);
          if(res.statusCode == 200){
            this.ModalComponent(SuccessDasComponent,'Degree Attestation Service',this.dasApplicationData.dasApplicationDto.referenceNumber)
            this.parentComp.goNext();
            this.cdr.detectChanges();
          }else{
            this.errorMsg=res.statusDescription;
            this.alertType='error';
            this.isError=true;
            this.loader=false;
            this.loaderService.setValue(this.loader);
            this.cdr.detectChanges();
          }
        },
        (err)=>{
          this.errorMsg='Somethng Went Wrong!, Please try again';
          this.alertType='error';
          this.isError=true;
          this.loader=false;
            this.loaderService.setValue(this.loader);
          this.cdr.detectChanges();
        }
      )
    }else if(this.formView == 'pucaRevision'){
      this.reviewDetailsService.submitReviseApplicationData(payload).subscribe(
        (res)=>{
          this.loader=false;
          this.loaderService.setValue(this.loader);
          if(res.statusCode == 200){
            this.ModalComponent(SuccessDasComponent,'Degree Attestation Service',this.dasApplicationData.dasApplicationDto.referenceNumber)
            this.parentComp.goNext();
            this.cdr.detectChanges();
          }else{
            this.errorMsg=res.statusDescription;
            this.alertType='error';
            this.isError=true;
            this.loader=false;
            this.loaderService.setValue(this.loader);
            this.cdr.detectChanges();
          }
        },
        (err)=>{
          this.errorMsg='Somethng Went Wrong!, Please try again';
          this.alertType='error';
          this.isError=true;
          this.loader=false;
            this.loaderService.setValue(this.loader);
          this.cdr.detectChanges();
        }
      )
    }

  }
  }

  public getDate(date): any {
    let convertedDate = new Date(date).toISOString();
    return convertedDate;
  }

  public getDegreesData(){
    for(let i=0; i < this.dasApplicationData.dasApplicationDto.dasDegrees.length;i++){
    for(let k=0; k < this.dropdownValuesForDas.map['6005'].length; k++){
          this.degreesData.push(this.dropdownValuesForDas.map['6005'][k])

    }
   }
}

 public getDocumentPagesCount(value: number, docValue, attestationType, index, degreeCase,stepIndex?) {
   for (let i = 0; i < this.attestationRates.length; i++) {
      if (this.attestationRates[i].documentTypeCodeId == docValue &&
        this.attestationRates[i].attestationTypeCodeId == attestationType) {
          if (attestationType == 60061) {
           this.amountForDegrees[stepIndex].degreeList[index]['original'] = this.amountForDegrees[stepIndex].degreeList[index]['original'] == null ? (this.attestationRates[i].rate * value) : Number(this.amountForDegrees[stepIndex].degreeList[index]['original'] + (this.attestationRates[i].rate * value));

            } else {
           this.amountForDegrees[stepIndex].degreeList[index]['photocopy'] = this.amountForDegrees[stepIndex].degreeList[index] == null ? (this.attestationRates[i].rate * value) : this.amountForDegrees[stepIndex].degreeList[index]['photocopy'] + (this.attestationRates[i].rate * value);

          }
      }
    }
   this.getTotalAmount()
}

public getTotalAmount() {
  if (this.amountForDegrees.length > 0) {
    for (let i = 0; i < this.amountForDegrees.length; i++) {
      for(let j=0; j < this.amountForDegrees[i].degreeList.length;j++){
       this.totalForLocal = this.amountForDegrees[i].degreeList.reduce(function (previousValue, currentValue) {
        return {
          original: previousValue.original + currentValue.original,
          photocopy: previousValue.photocopy + currentValue.photocopy
        }
      });
    }
      this.totalAmountForDegrees[i] = Number(this.totalForLocal.original + this.totalForLocal.photocopy)
      }
  }
 }


public goBack() {
  this.parentComp.goBack();
  this.cdr.detectChanges();
}

public goToDashboard(){
  this.router.navigate(['/'])
}

public markFormsTouched(form): void {
  CommonHelper.markFormGroupTouched(form);
}

public validate(f): boolean {
  if (f.status === 'VALID') {
    return true;
  }
}

public ModalComponent(Component, title, message) {
  const dialogRef = this.matDialog.open(Component, {
    width: '70vw',
    height: '60vh',
    backdropClass: 'custom-scrutiny-popup',
    panelClass: 'custom-scrutiny-popup',
    disableClose: true,
    autoFocus: false,
    data: { title: title, message: message }
  });
  dialogRef.afterClosed().subscribe(result => {
    if (!result || result) {
      this.router.navigate(['/'])
    }
  });
}

public cancelAttestaion() {
  this.router.navigate(['/dashboard'])
}

private createDegreeAttestationForm(): void {
  this.degreeAttestationForm = this.fb.group({
    degreeList: this.fb.array([
    ]),
  })
}

public getDegreeList() {
  const degreesList = this.degreeAttestationForm.controls.degreeList as FormArray;
  let newRow = this.fb.group({
    isDegreeAttestedBefore: new FormControl(null),
    isDegreeDuplicateCase: new FormControl(null),
    stampNumber: new FormControl(null),
    degree: new FormArray([])
  });
  degreesList.push(newRow);
}

public getAttestationList(index, documentValue, degreeData) {
  const attestationlist = this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree as FormArray;
  let newRow = this.fb.group({
    eduId: new FormControl(degreeData.cpEducationHistoryId),
    degreeId: new FormControl(),
    originalPages: new FormControl(0),
    photocopyPages: new FormControl(0),
    documentTypeCodeId: new FormControl(documentValue),
    photoCopyDocumentTypeCodeId: new FormControl(),
    originalDocumentTypeCodeId: new FormControl(),
    copyAttestationTypeCodeId: new FormControl(0),
    originalAttestationTypeCodeId: new FormControl(0),
    copyAttestationRateId: new FormControl(0),
    originalAttestationRateId: new FormControl(0),
    originalId: new FormControl(null),
    photocopyId: new FormControl(null),
  })
  attestationlist.push(newRow);
}

public setDataAttestationFormData() {
  for (let degreeIndex = 0; degreeIndex < this.dasApplicationData.dasApplicationDto.dasDegrees.length; degreeIndex++) {
    if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo.length > 0) {
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeAttestedBefore.patchValue(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].isDegreeAttestedBefore == true ? "1" : "0")
      this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].stampNumber.patchValue(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].stampNumber)
        this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].isDegreeDuplicateCase.patchValue(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].applicationAttestationTypeId == 600184 ? "1" : "0")
        this.duplicateStatus[degreeIndex]=this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].applicationAttestationTypeId == 600184 ? true : false;
      if(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.countryId == 1){
        this.getDegreeStatus(this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].isDegreeAttestedBefore == true ? "1" : "0", degreeIndex, this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].educationHistoryDto.countryId == 1, true)

     }
    }
  }
 this.attestationData = []
  for (let degreeIndex = 0; degreeIndex < this.dasApplicationData.dasApplicationDto.dasDegrees.length; degreeIndex++) {
    if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo.length > 0) {
      for (let attestationIndex = 0; attestationIndex < this.degreeAttestationForm.value.degreeList[degreeIndex].degree.length; attestationIndex++) {
        this.attestationData[attestationIndex] = {}
      }
    }
  }

  for (let degreeIndex = 0; degreeIndex < this.dasApplicationData.dasApplicationDto.dasDegrees.length; degreeIndex++) {
    if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo.length > 0) {

     for (let k = 0; k < this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo.length; k++) {
        for (let attestationIndex = 0; attestationIndex < this.degreeAttestationForm.value.degreeList[degreeIndex].degree.length; attestationIndex++) {
          if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ==
            this.degreeAttestationForm.value.degreeList[degreeIndex].degree[attestationIndex].documentTypeCodeId &&
            this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId == 60061) {
          this.attestationData[attestationIndex] = Object.assign(this.attestationData[attestationIndex], {
              originalPages: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages : 0,
              originalDocValue: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId : 0,
              originalAttestationType: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId : 0,
              originalId: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id : null,
            });
            this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.originalId.patchValue(this.attestationData[attestationIndex].originalId ? this.attestationData[attestationIndex].originalId : null)
            this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.originalPages.patchValue(this.attestationData[attestationIndex].originalPages ? this.attestationData[attestationIndex].originalPages : 0)
            this.getDocumentPagesCount(this.attestationData[attestationIndex].originalPages, this.attestationData[attestationIndex].originalDocValue, this.attestationData[attestationIndex].originalAttestationType, attestationIndex, 'local', degreeIndex)
          }

          else if (this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ==
            this.degreeAttestationForm.value.degreeList[degreeIndex].degree[attestationIndex].documentTypeCodeId &&
            this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId == 60062) {
            this.attestationData[attestationIndex] = Object.assign(this.attestationData[attestationIndex], {
              photocopyPages: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].numberOfPages : 0,
              photocopyValue: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].documentTypeCodeId : 0,
              copyAttestationType: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].attestationTypeCodeId : 0,
              photocopyId: this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id ? this.dasApplicationData.dasApplicationDto.dasDegrees[degreeIndex].degreeInfo[k].id : null,

            });
            this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.photocopyId.patchValue(this.attestationData[attestationIndex].photocopyId ? this.attestationData[attestationIndex].photocopyId : null)

            this.degreeAttestationForm.controls.degreeList['controls'][degreeIndex]['controls'].degree.controls[attestationIndex].controls.photocopyPages.patchValue(this.attestationData[attestationIndex].photocopyPages ? this.attestationData[attestationIndex].photocopyPages : 0)
            this.getDocumentPagesCount(this.attestationData[attestationIndex].photocopyPages, this.attestationData[attestationIndex].photocopyValue, this.attestationData[attestationIndex].copyAttestationType, attestationIndex, 'local', degreeIndex)
          }

      }
      }
     }
  }
}


public getDegreeStatus(beforeValue, index, degreeCase, isGet?) {
  this.degreeStatus[index] = beforeValue
  if (degreeCase && !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd &&
    !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation &&
    !this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isCAUniversity) {
    if (isGet == undefined) {
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.reset();
    }
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[1].controls.originalPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[2].controls.originalPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[3].controls.originalPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[1].controls.photocopyPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[2].controls.photocopyPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[3].controls.photocopyPages.patchValue(0);
    this.amountForDegrees[index].degreeList[0]['photocopy'] = 0;
    this.amountForDegrees[index].degreeList[1]['photocopy'] = 0;
    this.amountForDegrees[index].degreeList[2]['photocopy'] = 0;
    this.amountForDegrees[index].degreeList[3]['photocopy'] = 0;
    this.amountForDegrees[index].degreeList[0]['original'] = 0;
    this.amountForDegrees[index].degreeList[1]['original'] = 0;
    this.amountForDegrees[index].degreeList[2]['original'] = 0;
    this.amountForDegrees[index].degreeList[3]['original'] = 0;
  } else if (degreeCase && (this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.currentEnrolmentInd ||
    this.dasApplicationData.dasApplicationDto.dasDegrees[index].educationHistoryDto.isIncompleteEducation)) {
    if (isGet == undefined) {

      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.reset();
    }
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
    this.amountForDegrees[index].degreeList[0]['original'] = 0;
    this.amountForDegrees[index].degreeList[0]['photocopy'] = 0;
  }
  else {
    if (isGet == undefined) {
      this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.reset();
    }
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.originalPages.patchValue(0);
    this.degreeAttestationForm.controls.degreeList['controls'][index]['controls'].degree.controls[0].controls.photocopyPages.patchValue(0);
    this.amountForDegrees[index].degreeList[0]['photocopy'] = 0;
    this.amountForDegrees[index].degreeList[0]['original'] = 0;

  }

}

public viewComments(){
  const dialogRef = this.matDialog.open(CommentsListComponent, {
    width: '70vw',
    height: '60vh',
    backdropClass: 'landingpage-popup',
    panelClass: 'landingpage-popup-inner',
    disableClose: true,
    autoFocus: false,
    data: { appId: this.dasApplicationData.dasApplicationDto.id }
  });
}


}
